import {
  isRequired,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ name }) => isRequired(name) || { name: 'Collection name is required.' },
  ({ description }) => typeof description === 'string' || { description: 'Description should be string.' },
];

const KEYS = [
  'name',
  'description',
  'inactivated',
  'availableForAll',
  'availableForAllReadonly',
];

export {
  validations,
  KEYS,
};
